"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPayAtCourseExtrasSummary = void 0;
const dayjs = require("dayjs");
const course_1 = require("../course");
const currencyFormatter_1 = require("../currencyFormatter");
const getPayAtCourseExtrasSummary = (orderLines, exchange_rate) => {
    let rate = 1;
    if (!exchange_rate || exchange_rate?.rate === 1) {
        rate = 0;
    }
    else {
        rate = exchange_rate?.rate;
    }
    const extras = orderLines.map((line) => {
        const config = line?.latest_version.config;
        const extras = (0, course_1.getPayAtCourseExtras)(config);
        if (!extras)
            return null;
        return {
            title: extras.title,
            currency: line.currency,
            total_price: extras?.price || 0,
            total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(line.currency, extras?.price || 0, false),
            total_price_per_person: (Number(extras?.price || 0) / line.pax).toFixed(2),
            total_price_per_person_formatted: (0, currencyFormatter_1.currencyFormatter)(line.currency, Number(extras?.price || 0) / line.pax, false),
            display_currency: line.display_currency,
            display_total_price: Number(extras?.price || 0) * rate,
            display_price_per_person: ((Number(extras?.price || 0) * rate) /
                line.pax).toFixed(2),
            display_price_per_person_formatted: (0, currencyFormatter_1.currencyFormatter)(line.display_currency, (Number(extras?.price || 0) * rate) / line.pax, false),
            display_total_price_formatted: (0, currencyFormatter_1.currencyFormatter)(line.display_currency, Number((Number(extras?.price || 0) * rate).toFixed(2)), false),
            details: dayjs(config.where_when_who?.date).format("ddd, Do MMMM, YYYY"),
        };
    });
    return extras.filter((extra) => extra !== null);
};
exports.getPayAtCourseExtrasSummary = getPayAtCourseExtrasSummary;
